import { JWT_STORAGE_KEY, SESSION_FOR_CODE_HEADER_KEY, XSRF_TOKEN_STORAGE_KEY } from './STORAGE_KEYS';

/** Used for external forms because they cannot use cookies */
interface SessionConfig {
  jwt: string | null;
  xsrfToken: string | null;
  enabled: boolean;
}

/** internal global variable useful for debugging */
let isSessionConfigSet: 'true' | 'false' = 'false';

export function getSessionConfig(): SessionConfig {
  return {
    jwt: sessionStorage.getItem(JWT_STORAGE_KEY),
    xsrfToken: sessionStorage.getItem(XSRF_TOKEN_STORAGE_KEY),
    enabled: sessionStorage.getItem(SESSION_FOR_CODE_HEADER_KEY) === 'true'
  };
}
export function setSessionConfig(jwt: string | undefined, xsrfToken: string | undefined): void {
  if (xsrfToken) {
    sessionStorage.setItem(XSRF_TOKEN_STORAGE_KEY, xsrfToken);
  }
  if (jwt) {
    sessionStorage.setItem(JWT_STORAGE_KEY, jwt);
    isSessionConfigSet = 'true';
    sessionStorage.setItem(SESSION_FOR_CODE_HEADER_KEY, isSessionConfigSet);
  }
}

export function getSessionConfigForHTTPHeaders(): Record<string, string> {
  const { jwt, xsrfToken, enabled } = getSessionConfig();
  const headers: Record<string, string> = enabled
    ? {
        [SESSION_FOR_CODE_HEADER_KEY]: `true`
      }
    : {};

  if (jwt) {
    headers.Authorization = `Bearer ${jwt}`;
  }
  if (xsrfToken) {
    headers['X-XSRF-TOKEN'] = xsrfToken;
  }

  return headers;
}

export function clearSessionConfig(): void {
  sessionStorage.removeItem(JWT_STORAGE_KEY);
  sessionStorage.removeItem(XSRF_TOKEN_STORAGE_KEY);
  sessionStorage.removeItem(SESSION_FOR_CODE_HEADER_KEY);
  isSessionConfigSet = 'false';
}
